(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const image = root.querySelector('.al-product-image');
    const showImage = (src) => { if (!src || !image) return; image.removeAttribute('srcset'); image.src = src; };
    root.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
      showImage(button.dataset.gallerySrc);
      root.querySelectorAll('[data-gallery-src]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
    const form = root.querySelector('.al-form');
    if (!form) return;
    const add = form.querySelector('[data-add]');
    const status = form.querySelector('[data-status]');
    const success = form.querySelector('[data-cart-success]');
    let pending = false;
    const update = () => {
      const variant = form.querySelector('input[name="id"]:checked');
      if (!variant) return;
      root.querySelector('[data-color]').textContent = variant.dataset.title;
      root.querySelector('[data-price]').textContent = variant.dataset.price;
      add.disabled = pending || variant.dataset.available !== 'true';
      add.textContent = pending ? 'Añadiendo…' : (add.disabled ? 'Agotado' : 'Añadir a la cesta ↗');
      status.textContent = '';
      showImage(variant.dataset.image);
    };
    form.addEventListener('change', event => { if (event.target.name === 'id') update(); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (add.disabled || pending) return;
      pending = true;
      add.disabled = true;
      add.textContent = 'Añadiendo…';
      status.textContent = '';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'No se ha podido añadir. Inténtalo de nuevo.');
        status.textContent = 'Producto añadido a tu cesta.';
        success.hidden = false;
        root.querySelectorAll('[data-sticky-cart]').forEach(link => { link.href = link.dataset.cartUrl; link.textContent = 'Ir a la cesta →'; link.closest('.al-sticky').classList.add('has-cart'); });
        success.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'nearest'});
        try {
          const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
          if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('.al-cart').forEach(el => { el.querySelector('span').textContent = cart.item_count; el.setAttribute('aria-label', `Ir a la cesta, ${cart.item_count} artículos`); }); }
        } catch (_) { /* The item was added even if refreshing the counter fails. */ }
      } catch (error) { status.textContent = error.message || 'No se ha podido añadir. Inténtalo de nuevo.'; }
      finally { pending = false; const variant = form.querySelector('input[name="id"]:checked'); add.disabled = variant?.dataset.available !== 'true'; add.textContent = add.disabled ? 'Agotado' : 'Añadir a la cesta ↗'; }
    });
  }
  document.querySelectorAll('[data-alessia]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-alessia]').forEach(init));
})();
